import * as THREE from 'three'
const OWNED_THREE_RESOURCE_FLAG = '__ownedThreeResource'

type DisposableThreeResource = {
    dispose: () => void
    userData: Record<string, unknown>
}

function hasOwnedThreeResourceFlag(value: unknown): value is DisposableThreeResource {
    if (!value || typeof value !== 'object') {
        return false
    }
    const candidate = value as Partial<DisposableThreeResource>
    return (
        typeof candidate.dispose === 'function' &&
        typeof candidate.userData === 'object' &&
        candidate.userData !== null &&
        candidate.userData[OWNED_THREE_RESOURCE_FLAG] === true
    )
}

export function markForDisposal<T extends { userData: Record<string, unknown> }>(resource: T): void {
    resource.userData[OWNED_THREE_RESOURCE_FLAG] = true
}

export function disposeObject(root: THREE.Object3D) {
    const disposedResources = new Set<object>()
    const disposeResource = (resource: unknown) => {
        if (!hasOwnedThreeResourceFlag(resource)) {
            return
        }
        if (disposedResources.has(resource)) {
            return
        }
        resource.dispose()
        disposedResources.add(resource)
    }
    root.traverse((child) => {
        if (
            !(child instanceof THREE.Mesh) &&
            !(child instanceof THREE.Line) &&
            !(child instanceof THREE.Points)
        ) {
            return
        }

        disposeResource(child.geometry)

        if (Array.isArray(child.material)) {
            child.material.forEach(disposeResource)
            return
        }

        disposeResource(child.material)
    })
}
